<template>
  <Page heading="About MyLittlePonyCollection">
    <p>MyLittlePonyCollection is a resource for MLP collectors and admirers. Collectors can organize and track their collections, wishlists and favorite ponies. You can also browse through the many different generations of ponies.</p>
    <p>Search by color, mold, country and more.</p>
  </Page>
</template>

<script>
import { Page } from '../../layouts';

export default {
  name: 'About',
  components: {
    Page
  }
};
</script>
